/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AdminGroupMemberDto { 
    id: string;
    displayName: string;
    email: string;
    avatarUrl?: string;
    roleName: AdminGroupMemberDto.RoleNameEnum;
}
export namespace AdminGroupMemberDto {
    export type RoleNameEnum = 'Creator' | 'Main admin' | 'Admin' | 'Member';
    export const RoleNameEnum = {
        Creator: 'Creator' as RoleNameEnum,
        MainAdmin: 'Main admin' as RoleNameEnum,
        Admin: 'Admin' as RoleNameEnum,
        Member: 'Member' as RoleNameEnum
    };
}


